import React from 'react';

const DropDown = props => {
  const { info, list, value, handleSelection } = props;

  const options = list.map(listItem => {
    return (
      <option key={listItem.value} value={listItem.value}>
        {listItem.name}
      </option>
    );
  });

  const handleChange = event => {
    handleSelection(event.target.value);
  };

  return (
    <div>
      <label>{info ? <small>{info}</small> : ''}</label>
      <div>
        <select value={value.value} onChange={handleChange}>
          {options}
        </select>
      </div>
    </div>
  );
};

export default DropDown;
